import React from 'react';

interface HtmlPreviewCardProps {
  htmlContent: string;
}

export const HtmlPreviewCard: React.FC<HtmlPreviewCardProps> = () => {
  return null;
};
